import { render } from "./move-list.vue?vue&type=template&id=89deba8a"
import script from "./move-list.vue?vue&type=script&lang=js"
export * from "./move-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__